<template>
    <div class="remake_menu_container">
      <div class="remake_nav">
        <div class="remake_nav_bar">
            <div class="remake_nav_tab" @click="this.$root.OpenPopup('deposit')">
                충전신청
            </div>
            <div class="remake_nav_tab" @click="this.$root.OpenPopup('withdraw')">
                환전신청
            </div>
            <div class="remake_nav_tab" @click="this.$root.OpenPopup('money')">
                머니내역
            </div>
            <div class="remake_nav_tab" @click="this.$root.OpenPopup('notice')">
                공지사항
            </div>
            <!-- <div class="remake_nav_tab" @click="this.$root.OpenPopup('event')">
                이벤트
            </div> -->
            <div class="remake_nav_tab" @click="this.$root.OpenPopup('qna')">
                1:1문의
            </div>
        </div>
      </div>
    </div>
</template>
<script>
    
</script>

<style>
.remake_nav_bar{
    height: 100%;
    width: 800px;
    display: inline;
}
.remake_nav_tab{
    width: 120px;
    height: 100%;
    display: inline-block;
    cursor: pointer;
    color: white;
    font-size: 16px;
    text-align: center;
    margin-top: 15px;
}

.remake_menu_container{
    min-width: 900px;
    width: 100vw;
    height: 50px;
    background-color: #0d6efd;
}
.remake_nav{
    width: 900px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
</style>